"use client"
// src/layouts/x-up/x-up.tsx
import HistoricalShowCard from "@a24/ui/CardHistoricalShow";
import ProductCard from "@a24/ui/CardProduct";
import ShowCard from "@a24/ui/CardShow";
import Divider from "@a24/ui/Divider";
import Link from "@a24/ui/Link";
import Slider from "@a24/ui/Slider";
import Title from "@a24/ui/Title";
import { useEffect, useRef } from "react";
import { jsx, jsxs } from "react/jsx-runtime";
import { createElement } from "react";
var XUp = ({
  cta,
  cards,
  cardType = "show",
  className,
  stackVerticalyOnMobile = true,
  id,
  title
}) => {
  if (!cards) return null;
  const cardsRef = useRef([]);
  const cardComponents = {
    historical: HistoricalShowCard,
    product: ProductCard,
    show: ShowCard
  };
  useEffect(() => {
    if (cards) {
      cardsRef.current = cardsRef.current.slice(0, cards.length);
    }
  }, [cards]);
  let showNav = false;
  switch (cardType) {
    case "historical":
      showNav = cards.length > 2 || !stackVerticalyOnMobile;
      break;
    default:
      showNav = cards.length > 3 || !stackVerticalyOnMobile;
  }
  return /* @__PURE__ */ jsxs(
    "div",
    {
      className: `grid grid-cols-12 gap-x-6 ${className} max-md:px-6 max-2xl:px-16`,
      id,
      children: [
        /* @__PURE__ */ jsx("div", { className: "col-span-full row-span-1 row-start-1 md:col-span-8 md:col-start-1", children: title && /* @__PURE__ */ jsx(
          Title,
          {
            className: "heading-lg pb-10 md:pb-6",
            level: "h2",
            text: title
          }
        ) }),
        /* @__PURE__ */ jsx(
          "div",
          {
            className: ` content-start col-start-1 md:col-start-9 ${showNav ? stackVerticalyOnMobile ? "col-span-full md:col-span-3 md:pr-8" : "col-span-6 md:col-span-3 md:pr-8" : "col-span-full md:col-span-4 "}  md:text-end row-start-2 md:row-start-1 row-span-1 relative z-1`,
            children: cta && /* @__PURE__ */ jsx(
              Link,
              {
                className: `button-secondary ${stackVerticalyOnMobile ? "w-full" : ""} md:w-fit md:mt-[0.375rem] mb-6 md:mb-[1.625rem]`,
                href: cta.destination || "#",
                openNewTab: cta.isExternal,
                tracking: {
                  label: cta.label,
                  layout: "X-Up"
                },
                children: cta.label
              }
            )
          }
        ),
        /* @__PURE__ */ jsx("div", { className: "col-span-full row-span-1 row-start-3", children: /* @__PURE__ */ jsx(Divider, { className: "divider-default mb-6 md:mb-8" }) }),
        /* @__PURE__ */ jsx(
          Slider,
          {
            navigationClassName: `${stackVerticalyOnMobile ? "hidden md:block col-span-full md:col-span-2 md:col-start-11" : "col-span-6 col-start-7 md:col-span-2 md:col-start-11"} content-end row-span-1 row-start-2 md:row-start-1 text-end`,
            showNavigation: showNav,
            sliderClassName: `${stackVerticalyOnMobile ? "md:grid md:full-viewport-width" : "grid full-viewport-width"} ${cardType === "historical" ? "gap-x-3 lg:gap-x-[var(--gutter-big)]" : "md:gap-x-[var(--gutter)]"} grid-flow-col overflow-x-auto relative snap-x  no-scroll-bar col-span-full row-start-4  scroll-p-[var(--outter-gutter)] snap-mandatory`,
            slidesRef: cardsRef.current,
            children: cards.map((card, i) => {
              const CardComponent = cardComponents[cardType];
              const indentFirstItem = i === 0 ? `${stackVerticalyOnMobile ? "" : "ml-[var(--outter-gutter)]"} md:ml-[var(--outter-gutter)]` : "";
              const indentLastItem = i === cards.length - 1 ? `${stackVerticalyOnMobile ? "" : "mr-[var(--outter-gutter)]"} md:mr-[var(--outter-gutter)]` : "";
              return /* @__PURE__ */ createElement(
                CardComponent,
                {
                  ...card,
                  className: `${className} ${`row-start-${stackVerticalyOnMobile ? i + 1 : 1}`} ${cardType === "historical" ? "x-up-historical-card-width" : "md:x-up-card-width md:pb-2"} md:row-start-1 ${stackVerticalyOnMobile ? "pb-12 md:pb-2" : "pb-2"} last:pb-2 row-span-1 box-border snap-start   ${indentFirstItem} ${indentLastItem}`,
                  key: card.title,
                  ref: (el) => {
                    cardsRef.current[i] = el;
                  }
                }
              );
            })
          }
        )
      ]
    }
  );
};
var x_up_default = XUp;

export {
  x_up_default
};
